/* src/app/components/shared/redirect-notice/redirect-notice.component.scss */
.redirect-notice-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.28);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.redirect-notice-card {
  width: min(100%, 24rem);
  padding: 1.25rem 1.5rem;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 1.5rem 3rem rgba(15, 23, 42, 0.18);
  text-align: center;
}
.redirect-notice-title {
  margin: 0 0 0.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: #172554;
}
.redirect-notice-message {
  margin: 0;
  color: #334155;
  line-height: 1.5;
}
.redirect-notice-countdown {
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
  color: #64748b;
}
/*# sourceMappingURL=redirect-notice.component.css.map */
